import { render, staticRenderFns } from "./profileComercial.vue?vue&type=template&id=8cdbb3e0&"
import script from "./profileComercial.vue?vue&type=script&lang=js&"
export * from "./profileComercial.vue?vue&type=script&lang=js&"
import style0 from "./profileComercial.vue?vue&type=style&index=0&id=8cdbb3e0&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports